import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";
import router from "../../../../router";

const deleteInvoicePaymentItem = {
    namespaced: true,
    state: {
        isLoadingDeleteModal: false,
        modalDeleteData: {},
        isShowDeleteModal: false
    },
    mutations: {
        DELETE_INVOICE_PAYMENT_ITEM_SUCCESS(state, response) {
            const snackBarData = {
                title: response.data.message,
                message: response.data.data.textInfo,
            }
            eventBus.$emit('deleteInvoicePaymentItemSuccess', snackBarData);
            if (router.currentRoute.name === 'ProjectsEdit') {
                eventBus.$emit('refreshProjectData');
            }
        },
        DELETE_INVOICE_PAYMENT_ITEM_FAILURE(error) {
            console.log(error);
        },
    },
    actions: {
        deleteInvoicePaymentItemRequest: function({dispatch}, payload) {
            let promise = sendRequest("delete", config.baseURLApi + "/invoices/deleteInvoicePayment/" + payload.paymentId, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDeleteInvoicePaymentItem", result[1]);
                } else {
                    dispatch("failureDeleteInvoicePaymentItem", result[1]);
                }
            })
        },
        successDeleteInvoicePaymentItem: function({commit}, response) {
            commit("DELETE_INVOICE_PAYMENT_ITEM_SUCCESS", response);
        },
        failureDeleteInvoicePaymentItem: function({commit}, error) {
            commit("DELETE_INVOICE_PAYMENT_ITEM_FAILURE", error);
        },
    }
}

export default deleteInvoicePaymentItem;